
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import LenisScroll from './animation/smoothscroll'
import useMasterGsapAnimations from "./animation/animation";
import useScrollSectionGate from "./components/useScrollSectionGate";

import Home from './pages/index';
import About from './pages/abouts';
import Contact from './pages/contact';
import Masterplan from './pages/masterplan';
import Architectural from './pages/architectural';
import Nesting from './pages/nesting';
import Amenitiesz from './pages/amenitiesz';
import Hospitality from './pages/hospitality';
import Career from './pages/career';
import Partner from './pages/partner';


// Dashboard 
import Login from "./pages/dashboard/login"
import Dashboard from './pages/dashboard/userList';

function RouterContents() {
  useScrollSectionGate();

  return (
    <Routes>
      <Route path="/" exact element={<Home/>}/>
      <Route path="/aboutus" exact element={<About/>}/>
      <Route path="/contact" exact element={<Contact/>}/>
      <Route path="/masterplan" exact element={<Masterplan/>}/>
      <Route path="/architectural-consideration" exact element={<Architectural/>}/>
      <Route path="/fieldhouse" exact element={<Nesting/>}/>
      <Route path="/amenities" exact element={<Amenitiesz/>}/>
      <Route path="/biome-hospitality" exact element={<Hospitality/>}/>
      <Route path="/biome-career" exact element={<Career/>}/>
      <Route path="/biome-partner" exact element={<Partner/>}/>
      <Route path='/admin/biome-login' exact element={<Login/>}/>
      <Route path='/admin/biome-dashboard' exact element={<Dashboard/>}/>
    </Routes>
  );
}

function Routers () {
  LenisScroll();
  useMasterGsapAnimations();

  return (
    <Router>
      <RouterContents />
    </Router>
  );
}
export default Routers;